import {
  initialState,
  Actions,
  State,
  NEW_PERIODIC_CHECK,
  NEW_PERIODIC_CHECK_SUCCESS,
  NEW_PERIODIC_CHECK_ERROR,
  RESET_NEW_PERIODIC_CHECK,
} from '../../types/periodic-check/new'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case NEW_PERIODIC_CHECK:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case NEW_PERIODIC_CHECK_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case NEW_PERIODIC_CHECK_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_NEW_PERIODIC_CHECK:
      return initialState
    default:
      return state
  }
}

export default reducers
